<div class="delivery-address-wrapper">
  <div class="heading-wrapper">
    <span class="title">{{ 'myAccount.shipToAddress' | cxTranslate }}</span>
    <span class="sub-title">{{ 'myAccount.selectOneOrMultiple' | cxTranslate }}</span>
  </div>
  @if (unitAddressList$ | async; as data) {
  <div class="address-wrapper">
    @for (address of data.addresses; track address) { @if (address.approvalStatus !== 'PENDING') {
    <mat-checkbox
      #addressCheckbox
      disableRipple
      class="address-checkbox"
      [checked]="compareValue(address, userAddresses)"
      (change)="onChangeEventFunc(address, $event)"
    >
      @if (address.addressName) {
      <span class="address-name">{{ address.addressName }}: </span>
      }
      {{ address.formattedAddress }}
    </mat-checkbox>
    } }
  </div>
  }
</div>
